import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import checkStatus from '../utils/checkStatus';
import api from '../utils/api';
import dispatchHttpError from '../utils/dispatchHttpError';
import JwtStore from './JwtStore'

export default {
  getAllTerms() {
    return fetch(api('glossary'),{
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => {
        Dispatcher.dispatch({
          actionType: ActionTypes.GLOSSARY_GET_ALL_TERMS_COMPLETED,
          glossary: response.data
        });
      })
      .catch(dispatchHttpError);
  },
  getTermById(id){
    return fetch(api(`glossary/${id}`),{
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    }).then(checkStatus)
      .then(response => response.json())
      .then(response => {
        Dispatcher.dispatch({
          actionType: ActionTypes.GLOSSARY_GET_TERM_COMPLETED,
          term: response.data
        })
      })
  }
}
